export class BrowserNotification{
    constructor(payload, loggedInUserId) {
        if (Object.keys(payload).length ==0 || !Object.keys(payload).includes("title_callback") || !Object.keys(payload).includes("parent") || !Object.keys(payload).includes("icon_callback")
            || !Object.keys(payload).includes("body_callback") || !Object.keys(payload).includes("id") || !Object.keys(payload).includes("validator_callback")){
                throw 'id, parent, title and body keys are missing in payload'
            }
        this.id = payload.id
        this.loggedInUserId = loggedInUserId
        this.parent = payload.parent
        this.title_callback = payload.title_callback
        this.body_callback = payload.body_callback
        this.icon_callback = payload.icon_callback
        this.validator_callback = payload.validator_callback
        if (Object.keys(payload).includes("onclick_callbacks")){
            if (Array.isArray(payload.onclick_callbacks)){
                this.callbacks = payload.onclick_callbacks
            }else{
                throw 'callbacks in payload should be of type array'
            }
        }
        this.notification = null
        this.permission = Notification.permission
        this.requestPermission()
    }

    fire(event){
        if (this.validator_callback(event, this.loggedInUserId)){
            if(this.permission === "granted") {
                this.showNotification(event);
            } else if(this.permission === "default"){
                this.requestAndShowPermission(event);
            } 
        }
    }

    showNotification(event) {
        if(document.visibilityState === "visible") {
            return;
        }
        // console.log(event)
        this.notification = new Notification(this.title_callback(event, this.loggedInUserId), {
            icon: this.icon_callback(event, this.loggedInUserId),
            body: this.body_callback(event, this.loggedInUserId),
            tag: event.message_id
        });

        this.notification.onclick = () => { 
            this.notification.close();
            window.parent.focus();
            for (const callback of this.callbacks) {
                callback(event)
            }
        }
     }
     requestAndShowPermission(event) {
        Notification.requestPermission((permission) => {
            this.permission = permission
            if (this.permission === "granted") {
                this.showNotification(event);
            }
        });
     }

     requestPermission(){
        if (this.permission !== "granted"){
            Notification.requestPermission((permission) => {
                this.permission = permission
            })
        }
     }
}

class DispatcherEvent {
    constructor(eventName) {
        this.eventName = eventName;
        this.callbacks = [];
        this.browserNotifications = []
    }

    registerCallback(callback, parent) {
        let is_registered = this.callbacks.filter((func)=>func.parent==parent && func.callback.name==callback.name)
        if (is_registered.length==0){
            this.callbacks.push({callback:callback, parent:parent});
        }
    }

    unregisterCallback(callback, parent) {
        this.callbacks = this.callbacks.filter((func)=>func.parent!=parent && func.callback.name!=callback.name)
    }

    registerBrowserNotification(browserNotification) {
        let is_registered = this.browserNotifications.filter((func)=>func.parent==browserNotification.parent && func.id==browserNotification.id)
        if (is_registered.length==0){
            this.browserNotifications.push(browserNotification);
        }
    }

    unregisterBrowserNotification(id, parent) {
        this.browserNotifications = this.browserNotifications.filter((func)=>func.parent!=parent && func.id!=id)
    }

    fireBrowserNotifications(data){
        try {
            const callbacks = this.browserNotifications.slice(0);
            callbacks.forEach((obj) => {
                obj.fire(data);
            });   
        } catch (error) {
            console.error(`[Error while firing to Browser Notification--${error}]`)
        }
    }

    fire(data) {
        const callbacks = this.callbacks.slice(0);
        callbacks.forEach((func) => {
            try {
                func.callback(data);
            } catch (error) {
                console.error(`[Error while firing to registered callbacks--${error}]`)
            }
        });
        this.fireBrowserNotifications(data)
    }
}

// import {NotifierConstants} from "../components.constants.js"
// import {mapGetters} from "vuex"

export class WebSocketHandler {

    constructor(secure_websocket_url, loggedInUserId=null, useCallbackApproach=false) {
        //secure_websocket_url=`wss://${window.location.host}/dam_websocket`
        this.wssUrl = secure_websocket_url
        if ((!this.wssUrl.startsWith("ws://")) && (!this.wssUrl.startsWith("wss://"))) {
            console.error(`[init][WebSocketHandler][Invalid websocket url provided-->${this.wssUrl}]`)
            throw (`Invalid websocket url provided-->${this.wssUrl}]`)
        }
        this.events = {}
        this.mySocket = null
        this.retries = 0
        this.loggedInUserId = loggedInUserId
        this.useCallbackApproach = useCallbackApproach
            // this.connect()
    }

    async connect() {
        this.mySocket = new WebSocket(this.wssUrl);

        this.mySocket.onopen = () => {
            console.log(`[connect][WebSocketHandler][Connection to ${this.wssUrl} is open]`)
            console.log("WEBSOCKET-OPENED----OPEN--OPEN")
            this.dispatch("onopen", {})
            this.retries = 0
        };

        this.mySocket.onmessage = (event) => {
            if (event.data) {
                let message = JSON.parse(event.data)
                    // console.log(`[connect][WebSocketHandler][Connection to ${event.data} is open]`)
                    // console.log(`[Notification Message fro/m FUSION]`,message)
                this.dispatch(message.message_type, message)
            }
        };

        this.mySocket.onclose = (event) => {
            console.warn(`[connect][WebSocketHandler][Connection to ${this.wssUrl} is closed,reason->`, event)
            console.log("WEBSOCKET-CLOSED")
            this.dispatch("onclose", event)
            this.reconnect()
        };

        // this.mySocket.onerror = (event) =>{
        //     console.error(`[connect][WebSocketHandler][Connection to ${this.wssUrl} is closed,reason->`, event)
        //     this.dispatch("onerror", event)
        //     // this.reconnect()
        // }
    }

    reconnect(){
        setTimeout(()=>{
            this.retries += 1
            console.info(`[reconnect][WebSocketHandler][Trying to reconnect for every 5 seconds (<${this.retries} Retries>,<Waiting time ${this.retries*5}> seconds) ]`)
            this.connect()
        },5000)
    }

    closeWebsocket(){
        this.mySocket.onclose = function () {console.warn("[websocket][User logged-out closing cleanly]")}; 
        this.mySocket.close(3010, "User logged-out closing cleanly")
        delete this.mySocket
    }

    dispatch(eventName, data) {
        if (this.useCallbackApproach){
            const event = this.events[eventName];
            if (event) {
                event.fire(data);
            }
        }else{
            // console.log(eventName, data)
            const event = new CustomEvent(eventName, {detail:Object.assign({}, data)})
            if (event){
                window.dispatchEvent(event)
            }else{
                console.warn(`[dispatch][Failed to create event-->${eventName}]`)
            }
        }
    }

    registerForBrowserNotification(event, payload){
        try {
            if (Object.keys(payload).length!=0){
                event.registerBrowserNotification(new BrowserNotification(payload, this.loggedInUserId))
            }
        } catch (error) {
            console.error(`[Error while registering to Browser Notification-->${error}]`)
        }
    }

    addWSEventListener(eventName, callback, parent, browserNotificationPaylod={}) {
        let event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        // console.log(this.events)
        event.registerCallback(callback, parent);
        this.registerForBrowserNotification(event, browserNotificationPaylod)
    }

    removeWSEventListener(eventName, callback, parent, browserNotificationId=null) {
        const event = this.events[eventName];
        event.unregisterCallback(callback, parent);
        if (browserNotificationId != null){
            event.unregisterBrowserNotification(browserNotificationId, parent)
        }
        if (event.callbacks.length === 0) {
            delete this.events[eventName];
        }
        
    }
}

